import React from 'react'
import { FaFacebook, FaGithub, FaInstagram, FaLinkedinIn, FaPatreon, FaTwitter } from 'react-icons/fa'

import {
    FooterContainer,
    FooterSubHeading,
    FooterSubscription,
    FooterSubText,
    FooterLink,
    FooterLinkTitle,
    FooterLinksContainer,
    FooterLinksWrapper,
    FooterLinksItems,
    SocialMedia,
    SocialMediaWraper,
    SocialLogo,
    WebSiteRights,
    SocialIconLink,
    SocialIcon,
    SocialIcons

} from './Footer.elements'
export default function Footer() {
    return (
        <FooterContainer>
            <FooterSubscription>
                <FooterSubHeading>
                   Follow me On Instagram or Join me at Petrion 
                   to receive my latest blog posts.
                </FooterSubHeading>               
                <FooterSubText>
                    You can send me your problems or difficulties and 
                    I would like to help you!!!
                </FooterSubText>
            </FooterSubscription>
            
            <SocialMedia>
                <SocialMediaWraper>
                    <SocialLogo to="/">
                        <SocialIcon />
                            Rohaan                        
                    </SocialLogo>
                    <WebSiteRights> Rohaan &copy; 2020 </WebSiteRights>
                    <SocialIcons>
                    <SocialIconLink href="https://www.facebook.com/RohanJoshi2415" target="_blank" aria-label="Facebook"><FaFacebook/></SocialIconLink>
                    <SocialIconLink href="https://www.twitter.com/Rohan83670129?s=08" target="_blank" aria-label="Tweeter"><FaTwitter/></SocialIconLink>
                    <SocialIconLink href="https://www.instagram.com/pyjsdev" target="_blank" aria-label="Instagram"><FaInstagram/></SocialIconLink>
                    <SocialIconLink href="https://www.github.com/rjptechsolutions" target="_blank" aria-label="Github"><FaGithub/></SocialIconLink>
                    <SocialIconLink href="https://www.linkedin.com/in/rohaanjoshi/" target="_blank" aria-label="LinkedIn"><FaLinkedinIn/></SocialIconLink>                    
                    <SocialIconLink href="https://www.patreon.com/join/4797781" target="_blank" aria-label="Patreon"><FaPatreon/></SocialIconLink>
                    
                    </SocialIcons>                    
                </SocialMediaWraper>
            </SocialMedia>            
        </FooterContainer>
    )
}
